import React, { Component } from "react";
import Translation from "../translation/translation";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
//import $ from 'jquery';

class Edit extends Component {
    constructor(props) {
        super(props);
        var val = this.props.value;
        if (this.props.type === "date") {
            if (this.props.value === null) val = moment();
            else val = moment(this.props.value, "YYYYMMDD").format("DD.MM.YYYY");
        }
        this.state = {
            ShowValidation: false,
            Value: val,
            ShowOptions: false,
        };
        this.ChangeDateValue = this.ChangeDateValue.bind(this);
        this.ChangeValue = this.ChangeValue.bind(this);
        this.ToggleOptions = this.ToggleOptions.bind(this);
        this.SelectOption = this.SelectOption.bind(this);
    }

    ShowValidation(show) {
        this.setState({ ShowValidation: show });
    }

    IsValid() {
        var valid = this.state.Value !== "";
        this.setState({ ShowEnterValue: !valid });
        return valid;
    }

    ChangeDateValue(date) {
        // console.log("date", date);
        this.setState({ Value: date.format("DD.MM.YYYY") });
    }

    ChangeValue(e) {
        var val = e.target.value;
        if (this.props.datatype) {
            if (val === "") val = "0";
            if (this.props.datatype === "int") {
                try {
                    val = "" + parseInt(val, 10);
                } catch (ex) {
                    val = 0;
                }
            }
            if (this.props.datatype === "decimal") {
                try {
                    if (val.endsWith(".")) {
                        val = val.substring(0, val.length - 1);
                        val = "" + parseFloat(val) + ".";
                    } else val = "" + parseFloat(val);
                } catch (ex) {
                    val = 0;
                }
            }
        }

        this.setState({ Value: val });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.onchange) this.props.onchange();
    }

    GetValue() {
        return this.state.Value;
    }

    SetValue(value) {
        var realVal = value;
        if (this.props.type === "date") realVal = moment(value);
        this.setState({ Value: realVal });
    }

    SelectOption(value) {
        this.setState({ Value: value });
        this.ToggleOptions();
    }

    ToggleOptions() {
        this.setState({ ShowOptions: !this.state.ShowOptions });
    }

    render() {
        return this.props.type === "text" ? (
            <div>
                <input
                    type="text"
                    className="form-control"
                    value={this.state.Value}
                    onChange={this.ChangeValue}
                />
                {this.state.ShowValidation && this.state.ShowEnterValue ? (
                    <div className="alert alert-danger">{Translation.Trans("entervalue")}</div>
                ) : null}
            </div>
        ) : this.props.type === "date" ? (
            <div>
                <DatePicker
                    inputProps={{ placeholder: "N/A", readOnly: "true", className: "form-control pointhand" }}
                    value={this.state.Value}
                    showYearDropdown
                    onChange={this.ChangeDateValue}
                    dateFormat="DD.MM.YYYY"
                    timeFormat=""
                />
                {/* <Datetime
                            inputProps={{ placeholder: 'N/A', readOnly: "true", className: "form-control pointhand" }}
                            dateFormat="DD.MM.YYYY"
                            timeFormat=""
                            onChange={(e) => { this.ChangeDate(e, null); }}
                            value={this.state.StartDate}
                            closeOnSelect="true"
                        ></Datetime> */}
            </div>
        ) : this.props.type === "textarea" ? (
            <div>
                <textarea
                    rows={this.props.rows}
                    className="form-control"
                    onChange={this.ChangeValue}
                    value={this.state.Value}
                ></textarea>
                {this.state.ShowValidation && this.state.ShowEnterValue ? (
                    <div className="alert alert-danger">{Translation.Trans("entervalue")}</div>
                ) : null}
            </div>
        ) : this.props.type === "dropdown" ? (
            <div>
                <div className="col-md-11">
                    <input
                        type="text"
                        className="form-control"
                        value={this.state.Value}
                        onChange={this.ChangeValue}
                    />
                    {this.state.ShowValidation && this.state.ShowEnterValue ? (
                        <div className="alert alert-danger">{Translation.Trans("entervalue")}</div>
                    ) : null}
                    {this.state.ShowOptions ? (
                        <div className="dropDownDiv">
                            <ul className="list-group">
                                {this.props.options.map((item) => (
                                    <li
                                        className="list-group-item pointhand"
                                        onClick={() => this.SelectOption(item)}
                                    >
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ) : null}
                </div>
                <div className="col-md-1">
                    <button type="button" className="btn btn-default" onClick={() => this.ToggleOptions()}>
                        ...
                    </button>
                </div>
            </div>
        ) : null;
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/controls/edit.js